const modalCookies = document.getElementById("modal-cookies");
const footerCookies = document.getElementById("footer-cookies");

const onSetPreferences = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
  footerCookies.classList.remove("mr-flex");
  footerCookies.classList.add("mr-hidden");
  modalCookies.classList.remove("mr-hidden");
  modalCookies.classList.add("mr-fixed");
}

const savePreferences = () => {
  const operation = document.querySelector('#operation');
  const performance = document.querySelector('#performance');
  const preferences = document.querySelector('#preferences');
  const marketing = document.querySelector('#marketing');

  window.Shopify.customerPrivacy.setTrackingConsent(
    {
      "sale_of_data": operation,
      "preferences": preferences,
      "analytics": performance,
      "marketing": marketing,
    },
    callback
  );

}

const onAccept = () => {
  window.Shopify.customerPrivacy.setTrackingConsent(true, callback);
  console.log("Accept all preferences");
}

const onReject = () => {
  window.Shopify.customerPrivacy.setTrackingConsent(false, callback);
  console.log("Reject all preferences");
}

const onCloseModal = () => {
  // Show Footer
  footerCookies.classList.remove("mr-hidden");
  footerCookies.classList.add("mr-flex");

  // Close Modal
  modalCookies.classList.remove("mr-flex");
  modalCookies.classList.add("mr-hidden");
}


const showBanner = () => {
  const cookiesContainer = document.querySelector('#cookies-container');
  cookiesContainer.classList.remove('mr-hidden');
}

const initCookieBanner = () => {
  const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
  const userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();

  if (userCanBeTracked && userTrackingConsent === 'no_interaction') {
    showBanner();
  }
}

const callback = () => {
  const cookiesContainer = document.querySelector('#cookies-container');
  cookiesContainer.classList.add('mr-hidden');
  console.log("Done!")
}

window.Shopify.loadFeatures(
  [
    {
      name: 'consent-tracking-api',
      version: '0.1',
    },
  ],
  error => {
    if (error) {
      console.log(error)
    }
    initCookieBanner()
  },
);